import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";

const SideNav = ({
  hideNav,
  translateAction,
  backgroundColor,
  logouticon,
  logout,
  logoutBtn,
  iconBorderColor,
  iconBgColor,
  textColor,
  links,
}) => {
  return (
    <div
      className={`fixed inset-y-0 left-0 h-full w-[280px] ${backgroundColor} ${textColor} flex flex-col justify-start items-start z-50 transition-all ease-linear duration-[200ms] ${translateAction} xl:translate-x-0 border-r border-r-[#121212]`}
    >
      <div className="relative w-full min-h-[80px] flex justify-between items-center px-5">
        <div className="relative flex justify-start items-center h-full">
          <span className="font-logo font-[700] text-[18px] tracking-tight text-white">
            Zenit<span className="text-userDashPurple">chain</span>
          </span>
        </div>

        <button
          className="relative flex justify-end items-center xl:hidden"
          onClick={hideNav}
        >
          <AiOutlineClose className="cursor-pointer text-[20px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1] md:text-[22px]" />
        </button>
      </div>

      <div className="relative w-full px-5 pb-4">
        <p className="text-[13px] text-white font-[500]">Welcome, Admin</p>
        <p className="text-[11px] text-[#4a4a4a]">Administrator</p>
      </div>

      <div className="relative flex-grow w-full overflow-y-auto flex flex-col justify-start items-start space-y-4 py-[1rem]">
        <p className="px-3 text-[11px] font-[500] tracking-widest text-[#4a4a4a] uppercase">
          Menu
        </p>
        {links.map((link, index) => (
          <Link
            to={link.url}
            key={index}
            onClick={link.action && link.action}
            className="cursor-pointer flex w-full justify-between items-center border border-black rounded-md p-2 hover:bg-[#0c0c0c]"
          >
            <div className="flex justify-start items-center space-x-2 transition-all ease-in duration-300 hover:translate-x-[10px]">
              <div
                className={`w-[35px] h-[35px] flex justify-center items-center ${iconBgColor} ${iconBorderColor} rounded-full`}
              >
                {link.icon}
              </div>
              <p className="text-[#A9ABAD] font-dashheaderfont font-[200] text-[15px]">
                {link.name}
              </p>
            </div>
          </Link>
        ))}
      </div>

      <div className="relative w-full px-2 pb-[2rem]">
        <Link
          to={logout}
          onClick={logoutBtn}
          className="cursor-pointer flex w-[50%] justify-start items-center rounded-md p-1"
        >
          <div className="flex justify-start items-center space-x-2 transition-all ease-in duration-300">
            <div
              className={`flex justify-center items-center ${iconBgColor} ${iconBorderColor} rounded-full`}
            >
              {logouticon}
            </div>
            <p className="text-[#A9ABAD] font-dashheaderfont font-[200] text-[14px]">
              Sign Out
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default SideNav;
